module.exports = __webpack_public_path__ + "ui-icons_228ef1_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-icons_228ef1_256x240.png
// module id = 812
// module chunks = 1